import { Popover } from "antd";
import { useTranslation } from 'react-i18next';
import { Icon } from "Components/UI";
import { FC, useState } from "react";
import SpinCustom from "Components/UI/SpinCustom";
import { IMDTheme } from "Data/interfaces/MultiDomain/IMDTheme";
import { ActionButton, Line, MenuDropDown } from "./styles";

interface IActionButtons {
  loadingShareLink?: boolean;
  theme?: IMDTheme;
  hasDeletePermission?: boolean;
  hasEditPermission?: boolean;
  onCopyLink: () => void;
  onEdit: () => void;
  onDelete: () => void;
}

const ActionButtons: FC<IActionButtons> = ({
  loadingShareLink,
  theme,
  hasDeletePermission,
  hasEditPermission,
  onCopyLink,
  onEdit,
  onDelete,
}) => {
  const { t } = useTranslation('activities');
  const [open, setOpen] = useState(false);

  const handleOpenChange = (newOpen: boolean) => {
    setOpen(newOpen);
  };

  const handleCopyLink = () => {
    onCopyLink();
    setOpen(false);
  };

  const handleEdit = () => {
    onEdit();
    setOpen(false);
  };

  const handleDelete = () => {
    onDelete();
    setOpen(false);
  };

  const overlay = (
    <MenuDropDown>
      <span
        className="menuItem"
        onClick={handleCopyLink}
      >
        {loadingShareLink && (
          <SpinCustom
            size={14}
            marginRigth={14}
            color={theme?.colors.surface.onSurfaceVariant}
          />
        )}
        {!loadingShareLink && (
          <Icon
            icon="link"
            customSize={14}
            className="iconAction"
          />
        )}
        {t('moreActions.copyLink')}
      </span>
      {hasEditPermission && (
        <span
          className="menuItem"
          onClick={handleEdit}
        >
          <Icon
            icon="editar"
            customSize={14}
            className="iconAction"
          />
          {t('common.edit', { ns: 'common' })}
        </span>
      )}
      {hasDeletePermission && (
        <>
          <Line />
          <span
            className="menuItem"
            onClick={handleDelete}
          >
            <Icon
              icon="excluir"
              customSize={14}
              className="iconAction"
            />
            {t('moreActions.delete')}
          </span>
        </>
      )}
    </MenuDropDown>
  )

  return (
    <Popover
      content={overlay}
      placement="bottomRight"
      trigger="click"
      open={open}
      onOpenChange={handleOpenChange}
      overlayInnerStyle={{ padding: '4px 0 4px 0' }}
    >
      <ActionButton>
        <Icon
          icon="moreActions"
          customSize={16}
          className="iconMoreActions"
        />
      </ActionButton>
    </Popover>
  )
};

export default ActionButtons;
